class ProductPackSelector extends HTMLElement {
  constructor() {
    super();
    this.basePrice = parseInt(this.dataset.basePrice) || 0;
    this.init();
  }

  init() {
    const inputs = this.querySelectorAll('.pack-input');
    const quantityInput = document.querySelector('input[name="quantity"]');
    const quantitySelector = document.querySelector('product-quantity');
    const productForm = document.querySelector('form[data-type="add-to-cart-form"]');
    
    // Hide quantity selector since pack buttons control quantity
    if (quantitySelector) {
      quantitySelector.style.display = 'none';
    }
    
    // Ensure product-component has variant-selected class so price shows
    const productComponent = document.querySelector('.product-component') || document.querySelector('[data-js-product-component]');
    if (productComponent) {
      productComponent.classList.add('variant-selected');
    }
    
    // Also ensure the price element is visible
    const priceElement = document.querySelector('[data-update-block="price-extended"]');
    if (priceElement) {
      priceElement.style.display = 'flex';
      priceElement.style.visibility = 'visible';
      priceElement.style.opacity = '1';
    }
    
    // Create or update hidden input for custom price property
    this.ensurePricePropertyInput(productForm);
    
    inputs.forEach(input => {
      input.addEventListener('change', (e) => {
        // Prevent this from triggering variant change handlers
        e.stopPropagation();
        
        const quantity = parseInt(e.target.dataset.quantity);
        const customPrice = parseInt(e.target.dataset.price);
        
        // Get current selling plan selection BEFORE updating anything
        const currentSellingPlan = document.querySelector('input[name="selling_plan"]:checked');
        const isOneTimePurchase = currentSellingPlan && currentSellingPlan.value === 'one-time';
        const isSubscription = currentSellingPlan && currentSellingPlan.value !== 'one-time';
        
        // Update quantity input
        if (quantityInput) {
          quantityInput.value = quantity;
          // Trigger input event for any listeners
          quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
          quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          
          // Also trigger a custom event for Skio to detect quantity changes
          const quantityChangeEvent = new CustomEvent('quantity-changed', { 
            detail: { quantity: quantity },
            bubbles: true 
          });
          quantityInput.dispatchEvent(quantityChangeEvent);
        }
        
        // Update custom price property
        this.updatePriceProperty(productForm, customPrice, quantity);
        
        // Update selected state visually (using checked state for styling)
        this.querySelectorAll('.product-variant__item').forEach(item => {
          item.classList.remove('selected');
          const input = item.querySelector('input');
          if (input) {
            input.checked = false;
          }
        });
        const selectedItem = e.target.closest('.product-variant__item');
        selectedItem.classList.add('selected');
        e.target.checked = true;
        
        // Update price display based on current selling plan selection
        // Use setTimeout to ensure DOM is ready
        setTimeout(() => {
          // Re-check selling plan to ensure it hasn't changed
          const sellingPlanCheck = document.querySelector('input[name="selling_plan"]:checked');
          const oneTimePurchase = sellingPlanCheck && sellingPlanCheck.value === 'one-time';
          
          if (oneTimePurchase) {
            // Hide Skio subscription price displays
            const skioPriceElements = document.querySelectorAll('.skio-price .compare-price');
            skioPriceElements.forEach(element => {
              element.classList.remove('is-active');
              element.classList.add('is-have');
            });
            
            const skioFirstShipment = document.querySelectorAll('.skio-price .first_shipment_price');
            skioFirstShipment.forEach(element => {
              element.classList.remove('is-active');
            });
            
            const skioThereafter = document.querySelectorAll('.skio-price .thereafter_price');
            skioThereafter.forEach(element => {
              element.classList.remove('is-active');
            });
            
            // Clear any existing compare prices first
            this.clearCustomPriceDisplay();
            // Then update with new price for one-time purchase
            this.updatePriceDisplay(quantity);
          } else {
            // If subscription is selected, hide Skio prices and show our custom pricing
            const skioFirstShipment = document.querySelectorAll('.skio-price .first_shipment_price');
            skioFirstShipment.forEach(element => {
              element.classList.remove('is-active');
            });
            
            const skioThereafter = document.querySelectorAll('.skio-price .thereafter_price');
            skioThereafter.forEach(element => {
              element.classList.remove('is-active');
            });
            
            const skioComparePrice = document.querySelectorAll('.skio-price .compare-price');
            skioComparePrice.forEach(element => {
              element.classList.remove('is-active');
              element.classList.add('is-have');
            });
            
            // Update price display with 10% discount
            this.updatePriceDisplay(quantity);
          }
        }, 50);
      });
    });
    
    // Set initial state
    const checkedInput = this.querySelector('.pack-input:checked');
    if (checkedInput && quantityInput) {
      const initialQuantity = parseInt(checkedInput.dataset.quantity);
      const initialPrice = parseInt(checkedInput.dataset.price);
      quantityInput.value = initialQuantity;
      this.updatePriceProperty(productForm, initialPrice, initialQuantity);
      
      // Ensure price element is visible
      const priceElement = document.querySelector('[data-update-block="price-extended"]');
      if (priceElement) {
        priceElement.style.display = 'flex';
        priceElement.style.visibility = 'visible';
        priceElement.style.opacity = '1';
      }
      
      // Only update price display if one-time purchase is selected
      const oneTimePurchase = document.querySelector('input[name="selling_plan"][value="one-time"]:checked');
      if (oneTimePurchase) {
        // Hide Skio subscription price displays on initial load
        const skioPriceElements = document.querySelectorAll('.skio-price .compare-price');
        skioPriceElements.forEach(element => {
          element.classList.remove('is-active');
          element.classList.add('is-have');
        });
        
        const skioFirstShipment = document.querySelectorAll('.skio-price .first_shipment_price');
        skioFirstShipment.forEach(element => {
          element.classList.remove('is-active');
        });
        
        const skioThereafter = document.querySelectorAll('.skio-price .thereafter_price');
        skioThereafter.forEach(element => {
          element.classList.remove('is-active');
        });
        
        // Small delay to ensure DOM is ready
        setTimeout(() => {
          this.updatePriceDisplay(initialQuantity);
        }, 100);
      } else {
        // For subscription, also update price display
        setTimeout(() => {
          this.updatePriceDisplay(initialQuantity);
        }, 100);
      }
    }
    
    // Setup listener for subscription/one-time toggle
    this.setupSubscriptionToggleListener();
    
    // Force price to be visible and ensure layout
    this.ensurePriceVisible();
  }
  
  ensurePriceVisible() {
    // Ensure product component has variant-selected class
    const productComponent = document.querySelector('.product-component') || document.querySelector('[data-js-product-component]');
    if (productComponent) {
      productComponent.classList.add('variant-selected');
    }
    
    // Force product-actions layout
    const productActions = document.querySelector('.product-actions');
    if (!productActions) {
      console.warn('Pack selector: product-actions not found');
      return;
    }
    
    productActions.style.display = 'flex';
    productActions.style.flexDirection = 'row';
    productActions.style.alignItems = 'center';
    productActions.style.justifyContent = 'flex-start';
    
    // Find or create price element
    let priceContainer = productActions.querySelector('[data-update-block="price-extended"]') ||
                         productActions.querySelector('.product-actions__price');
    
    if (!priceContainer) {
      // Create price element if it doesn't exist
      console.log('Pack selector: Creating price element');
      priceContainer = document.createElement('div');
      priceContainer.setAttribute('data-update-block', 'price-extended');
      priceContainer.className = 'product-actions__price show-block-if-variant-selected';
      
      // Create product-price structure
      const productPriceDiv = document.createElement('div');
      productPriceDiv.className = 'product-price';
      const priceOriginal = document.createElement('span');
      priceOriginal.className = 'product-price--original';
      priceOriginal.textContent = '$0.00';
      productPriceDiv.appendChild(priceOriginal);
      priceContainer.appendChild(productPriceDiv);
      
      // Insert before product-form
      const productForm = productActions.querySelector('.product-form');
      if (productForm) {
        productActions.insertBefore(priceContainer, productForm);
      } else {
        productActions.appendChild(priceContainer);
      }
    }
    
    // Ensure price is on left, button on right
    priceContainer.style.order = '1';
    priceContainer.style.marginRight = 'auto';
    priceContainer.style.display = 'flex';
    priceContainer.style.visibility = 'visible';
    priceContainer.style.opacity = '1';
    priceContainer.style.position = 'relative';
    priceContainer.style.zIndex = '10';
    
    const productForm = productActions.querySelector('.product-form');
    if (productForm) {
      productForm.style.order = '2';
      productForm.style.marginLeft = 'auto';
      productForm.style.position = 'relative';
      productForm.style.zIndex = '1';
    }
    
    // Ensure subscription boxes don't overlap price
    const subscriptionApp = document.querySelector('.skio_subscription_app');
    if (subscriptionApp) {
      subscriptionApp.style.position = 'relative';
      subscriptionApp.style.zIndex = '0';
    }
  }

  setupSubscriptionToggleListener() {
    // Use a flag to prevent duplicate listeners
    if (this._subscriptionListenerSetup) return;
    this._subscriptionListenerSetup = true;
    
    // Add listener to subscription/one-time toggle
    const sellingPlanInputs = document.querySelectorAll('input[name="selling_plan"]');
    sellingPlanInputs.forEach(input => {
      input.addEventListener('change', () => {
        // Small delay to ensure Skio has updated its price display first
        setTimeout(() => {
          const checkedInput = this.querySelector('.pack-input:checked');
          const oneTimePurchase = document.querySelector('input[name="selling_plan"][value="one-time"]:checked');
          const isSubscription = !oneTimePurchase;
          
          if (oneTimePurchase && checkedInput) {
            // Hide Skio subscription price displays
            const skioPriceElements = document.querySelectorAll('.skio-price .compare-price');
            skioPriceElements.forEach(element => {
              element.classList.remove('is-active');
              element.classList.add('is-have');
            });
            
            const skioFirstShipment = document.querySelectorAll('.skio-price .first_shipment_price');
            skioFirstShipment.forEach(element => {
              element.classList.remove('is-active');
            });
            
            const skioThereafter = document.querySelectorAll('.skio-price .thereafter_price');
            skioThereafter.forEach(element => {
              element.classList.remove('is-active');
            });
            
            // Update price for one-time purchase
            const quantity = parseInt(checkedInput.dataset.quantity);
            this.updatePriceDisplay(quantity);
          } else if (isSubscription) {
            // For subscriptions, hide Skio's FIRST SHIPMENT and THEREAFTER prices
            const skioFirstShipment = document.querySelectorAll('.skio-price .first_shipment_price');
            skioFirstShipment.forEach(element => {
              element.classList.remove('is-active');
            });
            
            const skioThereafter = document.querySelectorAll('.skio-price .thereafter_price');
            skioThereafter.forEach(element => {
              element.classList.remove('is-active');
            });
            
            const skioComparePrice = document.querySelectorAll('.skio-price .compare-price');
            skioComparePrice.forEach(element => {
              element.classList.remove('is-active');
              element.classList.add('is-have');
            });
            
            // Update price display with 10% discount
            if (checkedInput) {
              const quantity = parseInt(checkedInput.dataset.quantity);
              this.updatePriceDisplay(quantity);
            }
          }
        }, 150);
      });
    });
  }

  clearCustomPriceDisplay() {
    // Find all price elements and remove compare price (strikethrough)
    const priceElements = [
      document.querySelector('[data-update-block="price-extended"]'),
      document.querySelector('[data-update-block="price-compact"]'),
      document.querySelector('.product-actions__price')
    ].filter(el => el !== null);
    
    priceElements.forEach(element => {
      const compareSpan = element.querySelector('.product-price--compare');
      if (compareSpan) {
        compareSpan.remove();
      }
    });
    
    // Hide Skio subscription price displays when one-time purchase is selected
    const skioPriceElements = document.querySelectorAll('.skio-price .compare-price');
    skioPriceElements.forEach(element => {
      element.classList.remove('is-active');
      element.classList.add('is-have');
    });
    
    const skioFirstShipment = document.querySelectorAll('.skio-price .first_shipment_price');
    skioFirstShipment.forEach(element => {
      element.classList.remove('is-active');
    });
    
    const skioThereafter = document.querySelectorAll('.skio-price .thereafter_price');
    skioThereafter.forEach(element => {
      element.classList.remove('is-active');
    });
  }

  ensurePricePropertyInput(form) {
    if (!form) return;
    
    // Check if property input already exists
    let priceInput = form.querySelector('input[name="properties[_Custom Pack Price]"]');
    if (!priceInput) {
      // Create hidden input for custom price property
      priceInput = document.createElement('input');
      priceInput.type = 'hidden';
      priceInput.name = 'properties[_Custom Pack Price]';
      form.appendChild(priceInput);
    }
    
    // Also create input for pack size
    let packSizeInput = form.querySelector('input[name="properties[_Pack Size]"]');
    if (!packSizeInput) {
      packSizeInput = document.createElement('input');
      packSizeInput.type = 'hidden';
      packSizeInput.name = 'properties[_Pack Size]';
      form.appendChild(packSizeInput);
    }
  }

  updatePriceProperty(form, priceInCents, quantity) {
    if (!form) return;
    
    const priceInput = form.querySelector('input[name="properties[_Custom Pack Price]"]');
    const packSizeInput = form.querySelector('input[name="properties[_Pack Size]"]');
    
    if (priceInput) {
      const priceInDollars = (priceInCents / 100).toFixed(2);
      priceInput.value = `$${priceInDollars}`;
    }
    
    if (packSizeInput) {
      packSizeInput.value = `${quantity} PACK`;
    }
  }

  updatePriceDisplay(quantity) {
    // Check if subscription or one-time purchase is selected
    const oneTimePurchase = document.querySelector('input[name="selling_plan"][value="one-time"]:checked');
    const isSubscription = !oneTimePurchase;
    
    // Get the price from the selected input's data-price attribute
    const selectedInput = this.querySelector('.pack-input:checked');
    if (!selectedInput) {
      console.warn('Pack selector: No selected input found');
      return;
    }
    
    // Get the one-time purchase price and compare price
    const oneTimePrice = parseInt(selectedInput.dataset.price);
    const oneTimeComparePrice = parseInt(selectedInput.dataset.comparePrice) || 0;
    let totalPrice, comparePrice;
    // Calculate pack-level discount percent (for 4-pack / 12-pack)
    const packDiscountPercent = oneTimeComparePrice > 0 && oneTimeComparePrice > oneTimePrice
      ? Math.round(((oneTimeComparePrice - oneTimePrice) / oneTimeComparePrice) * 100)
      : 0;
    
    if (isSubscription) {
      // Calculate per-unit with rounding to match Shopify's calculation
      const unitPriceBeforeSubscription = oneTimePrice / quantity; // per unit after pack discount
      const unitPriceAfterSubscription = Math.round(unitPriceBeforeSubscription * 0.90); // 10% off, rounded to nearest cent
      totalPrice = unitPriceAfterSubscription * quantity;
      // For subscription, show the one-time purchase price as compare price (strikethrough)
      comparePrice = oneTimePrice;
    } else {
      // For one-time purchase, use the custom pack price from data attribute
      totalPrice = oneTimePrice;
      // Show compare price if it exists (for 4 PACK and 12 PACK)
      comparePrice = oneTimeComparePrice;
    }
    
    if (isNaN(totalPrice)) {
      console.warn('Pack selector: Invalid price in data-price attribute:', selectedInput.dataset.price);
      return;
    }
    
    // Try multiple selectors to find the price element
    // Force price to be visible before updating
    this.ensurePriceVisible();
    
    // Try to find price element in product-actions first
    const productActions = document.querySelector('.product-actions');
    let priceElement = null;
    
    const meta = { isSubscription, packDiscountPercent };
    if (productActions) {
      // Look for price-extended in product-actions
      priceElement = productActions.querySelector('[data-update-block="price-extended"]') ||
                     productActions.querySelector('.product-actions__price') ||
                     productActions.querySelector('.product-price');
      
      if (priceElement) {
        priceElement.style.display = 'flex';
        priceElement.style.visibility = 'visible';
        priceElement.style.opacity = '1';
        console.log('Found price element in product-actions:', priceElement.className);
        this.updatePriceInElement(priceElement, totalPrice, comparePrice, meta);
        return;
      }
    }
    
    // Fallback: try to find price-extended anywhere
    const priceExtended = document.querySelector('[data-update-block="price-extended"]');
    if (priceExtended) {
      priceExtended.style.display = 'flex';
      priceExtended.style.visibility = 'visible';
      priceExtended.style.opacity = '1';
      console.log('Found price-extended element');
      this.updatePriceInElement(priceExtended, totalPrice, comparePrice, meta);
      return;
    }
    
    // Last resort: create price element if it doesn't exist
    if (productActions && !priceElement) {
      console.warn('Pack selector: Price element not found, creating it');
      const newPriceDiv = document.createElement('div');
      newPriceDiv.setAttribute('data-update-block', 'price-extended');
      newPriceDiv.className = 'product-actions__price show-block-if-variant-selected';
      newPriceDiv.style.display = 'flex';
      newPriceDiv.style.visibility = 'visible';
      newPriceDiv.style.opacity = '1';
      
      // Insert before product-form
      const productForm = productActions.querySelector('.product-form');
      if (productForm) {
        productActions.insertBefore(newPriceDiv, productForm);
      } else {
        productActions.appendChild(newPriceDiv);
      }
      
      this.updatePriceInElement(newPriceDiv, totalPrice, comparePrice, meta);
    } else {
      console.warn('Pack selector: Could not find product-actions element');
    }
  }

  updatePriceInElement(element, totalPriceInCents, comparePriceInCents = 0, meta = {}) {
    // First, always remove any existing compare price to start fresh
    const existingCompareSpan = element.querySelector('.product-price--compare');
    if (existingCompareSpan) {
      existingCompareSpan.remove();
    }
    
    // Format prices using Shopify's money format
    const priceInDollars = (totalPriceInCents / 100).toFixed(2);
    const priceFormatted = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(priceInDollars);
    const priceHtml = this.formatPriceHtml(priceFormatted);
    
    const hasComparePrice = comparePriceInCents > 0 && comparePriceInCents > totalPriceInCents;
    let comparePriceFormatted = '';
    let comparePriceHtml = '';
    if (hasComparePrice) {
      const compareInDollars = (comparePriceInCents / 100).toFixed(2);
      comparePriceFormatted = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(compareInDollars);
      comparePriceHtml = this.formatPriceHtml(comparePriceFormatted);
    }
    
    console.log('Updating price element:', {
      totalPrice: priceFormatted,
      comparePrice: hasComparePrice ? comparePriceFormatted : 'none',
      element: element,
      elementClass: element.className,
      elementId: element.id
    });
    
    // Force element to be visible
    element.style.display = 'flex';
    element.style.visibility = 'visible';
    element.style.opacity = '1';
    
    // Find the price container
    const priceContainer = element.querySelector('.product-price') || element;
    
    // Calculate savings percentage if we have a compare price
    let savingsPercentage = 0;
    if (hasComparePrice) {
      const savingsAmount = comparePriceInCents - totalPriceInCents;
      savingsPercentage = Math.round((savingsAmount / comparePriceInCents) * 100);
    }
    
    // Update all price spans - look for .product-price--original FIRST (current price comes first)
    const priceSpans = priceContainer.querySelectorAll('.product-price--original');
    let updated = false;
    
    if (priceSpans.length > 0) {
      priceSpans.forEach(span => {
        // Remove any existing content and set the new price
        const visuallyHidden = span.querySelector('.visually-hidden');
        if (visuallyHidden) {
          // Keep the visually-hidden span, replace the rest with new price
          span.innerHTML = visuallyHidden.outerHTML + ' ' + priceHtml;
        } else {
          // Just set the formatted price
          span.innerHTML = priceHtml;
        }
        // Ensure consistent font size
        span.style.fontSize = '3rem';
        span.style.fontWeight = 'bold';
        updated = true;
      });
    } else {
      // If no .product-price--original exists, create it
      const newPriceSpan = document.createElement('span');
      newPriceSpan.className = 'product-price--original';
      newPriceSpan.style.fontSize = '3rem';
      newPriceSpan.style.fontWeight = 'bold';
      const visuallyHidden = document.createElement('span');
      visuallyHidden.className = 'visually-hidden';
      visuallyHidden.textContent = 'Regular price';
      newPriceSpan.appendChild(visuallyHidden);
      const priceWrapper = document.createElement('span');
      priceWrapper.innerHTML = ' ' + priceHtml;
      newPriceSpan.appendChild(priceWrapper);
      priceContainer.appendChild(newPriceSpan);
      updated = true;
    }
    
    // Update or create compare price (strikethrough) AFTER the current price if needed
    if (hasComparePrice) {
      let compareSpan = priceContainer.querySelector('.product-price--compare');
      if (!compareSpan) {
        compareSpan = document.createElement('div');
        compareSpan.className = 'product-price--compare';
        
        // Insert AFTER the original price (to the right)
        const originalSpan = priceContainer.querySelector('.product-price--original');
        if (originalSpan && originalSpan.parentNode) {
          originalSpan.parentNode.insertBefore(compareSpan, originalSpan.nextSibling);
        } else {
          priceContainer.appendChild(compareSpan);
        }
      }
      
      // Update compare price content - strikethrough price on top, savings below
      compareSpan.style.display = 'flex';
      compareSpan.style.flexDirection = 'column';
      compareSpan.style.alignItems = 'flex-start';
      compareSpan.style.visibility = 'visible';
      compareSpan.style.opacity = '1';
      
      const strikethroughPrice = document.createElement('del');
      strikethroughPrice.style.textDecoration = 'line-through';
      strikethroughPrice.style.fontSize = 'inherit';
      strikethroughPrice.innerHTML = comparePriceHtml || comparePriceFormatted;
      
      const savingsText = document.createElement('span');
      savingsText.className = 'product-price--savings';
      
      // If subscription, show stacked discount text (10% + pack % if applicable)
      if (meta.isSubscription) {
        const subPercent = 10;
        const packPercent = meta.packDiscountPercent || 0;
        if (packPercent > 0) {
          // Pack discount: normal text color; Subscription 10%: bold red
          savingsText.innerHTML = `(Save ${packPercent}% <span style="font-weight:700">+</span> <span style="font-weight:700;font-size:0.9em">addt'l</span> <span style="font-weight:700;color:#B85130">${subPercent}%</span>)`;
        } else {
          // Subscription only
          savingsText.innerHTML = `(Save <span style="font-weight:700;color:#B85130">${subPercent}%</span>)`;
        }
      } else {
        savingsText.textContent = `(Save ${savingsPercentage}%)`;
      }
      
      compareSpan.innerHTML = '';
      compareSpan.appendChild(strikethroughPrice);
      compareSpan.appendChild(savingsText);
    } else {
      // Remove compare price if it exists and we don't need it (for 2 PACK)
      const compareSpan = priceContainer.querySelector('.product-price--compare');
      if (compareSpan) {
        compareSpan.remove();
      }
    }
    
    // If we didn't update via .product-price--original, try other methods
    if (!updated) {
      // Try to find and update any price-like text in the element
      const allTextNodes = this.getTextNodes(element);
      allTextNodes.forEach(node => {
        const text = node.textContent || '';
        const pricePattern = /\$[\d,]+\.?\d*/g;
        if (pricePattern.test(text)) {
          node.textContent = text.replace(pricePattern, priceFormatted);
          updated = true;
        }
      });
      
      // If still not updated, try updating the entire element's text
      if (!updated) {
        const text = element.textContent || element.innerText || '';
        const pricePattern = /\$[\d,]+\.?\d*/g;
        if (pricePattern.test(text)) {
          element.textContent = text.replace(pricePattern, priceFormatted);
          updated = true;
        } else {
          // Last resort: append the price
          const priceDiv = element.querySelector('.product-price') || element;
          if (priceDiv) {
            const existingPrice = priceDiv.querySelector('.product-price--original');
            if (existingPrice) {
              existingPrice.innerHTML = priceHtml;
              // Ensure consistent font size
              existingPrice.style.fontSize = '3rem';
              existingPrice.style.fontWeight = 'bold';
            } else {
              const newPriceSpan = document.createElement('span');
              newPriceSpan.className = 'product-price--original';
              newPriceSpan.style.fontSize = '3rem';
              newPriceSpan.style.fontWeight = 'bold';
              newPriceSpan.innerHTML = priceHtml;
              priceDiv.appendChild(newPriceSpan);
            }
            updated = true;
          }
        }
      }
    }
    
    // Force a re-render by dispatching a custom event
    if (updated) {
      element.dispatchEvent(new CustomEvent('price-updated', { 
        detail: { price: totalPriceInCents, formatted: priceFormatted } 
      }));
    }
  }

  formatPriceHtml(priceString) {
    if (typeof priceString !== 'string') return priceString;
    const symbolMatch = priceString.match(/^[^\d-]+/);
    const symbol = symbolMatch ? symbolMatch[0] : '';
    const trailingMatch = priceString.match(/([A-Za-z]{2,})$/);
    const trailing = trailingMatch ? trailingMatch[1] : '';

    const numeric = Number(priceString.replace(/[^0-9.-]/g, ''));
    if (Number.isNaN(numeric)) return priceString;

    const normalized = numeric.toFixed(2);
    const [wholeRaw, cents = '00'] = normalized.split('.');
    const dollars = Number(wholeRaw).toLocaleString('en-US');

    const centsPart = cents === '00' ? '' : `<span class="price__cents">.${cents}</span>`;
    const trailingPart = trailing ? `<span class="price__iso">${trailing}</span>` : '';

    return `${symbol}${dollars}${centsPart}${trailingPart}`;
  }

  getTextNodes(element) {
    const textNodes = [];
    const walker = document.createTreeWalker(
      element,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    let node;
    while (node = walker.nextNode()) {
      textNodes.push(node);
    }
    return textNodes;
  }
}

if (!customElements.get('product-pack-selector')) {
  customElements.define('product-pack-selector', ProductPackSelector);
}

